import posthog from 'posthog-js';
import { getAnalyticsConsent } from '@/lib/consent';

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://us.i.posthog.com';

export function initPosthog() {
  if (!key) {
    return;
  }
  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    persistence: 'localStorage+cookie',
  });
}

export function capture(event: string, properties?: Record<string, any>) {
  if (!key) {
    return;
  }
  const consent = getAnalyticsConsent();
  if (consent !== true) return;
  posthog.capture(event, properties);
}

export function identify(userId: string, props?: Record<string, any>) {
  if (!key) return;
  const consent = getAnalyticsConsent();
  if (consent !== true) return;
  posthog.identify(userId, props);
}

export function disablePosthog() {
  try {
    posthog.opt_out_capturing();
  } catch {}
}

// Minimal, cookieless analytics: memory-only, no autocapture, no session replay.
export function initCookielessPosthog() {
  if (!key) return;
  try {
    posthog.init(key, {
      api_host: host,
      autocapture: false,
      capture_pageview: true,
      persistence: 'memory',
      disable_session_recording: true,
    });
  } catch (e) {
  }
}

